import { useCallback, useEffect, useState } from 'react';
import { listContractValidations } from 'services/actions/contract_validations';
import { ContractsAnalysisItemTypes } from 'store/modules/contract_analysis/types';

const POLLING_INTERVAL = 15000;

interface State {
  id: number | null;
  validations: ContractsAnalysisItemTypes[];
  error: boolean;
}

export function useContractValidations(biddingId: number | null) {
  const [state, setState] = useState<State>({ id: null, validations: [], error: false });
  const [version, setVersion] = useState(0);

  const reload = useCallback(() => setVersion((current) => current + 1), []);

  useEffect(() => {
    if (!biddingId) {
      setState({ id: null, validations: [], error: false });
      return undefined;
    }

    let active = true;

    listContractValidations(biddingId)
      .then((response) => {
        if (!active) return;
        const list = response?.data?.data;
        if (!Array.isArray(list)) {
          setState({ id: biddingId, validations: [], error: true });
          return;
        }
        setState({ id: biddingId, validations: list, error: false });
      })
      .catch((err) => {
        console.error(`Erro ao listar as análises de contrato da licitacao ${biddingId}:`, err);
        if (active) setState({ id: biddingId, validations: [], error: true });
      });

    return () => {
      active = false;
    };
  }, [biddingId, version]);

  const settled = state.id === biddingId;
  const hasPending = settled && state.validations.some((item) => item.status === 'pending');

  useEffect(() => {
    if (!hasPending) return undefined;

    const timer = setTimeout(reload, POLLING_INTERVAL);
    return () => clearTimeout(timer);
  }, [hasPending, state, reload]);

  return {
    validations: settled ? state.validations : [],
    loading: !!biddingId && !settled,
    error: settled && state.error,
    reload,
  };
}
